export const styles = {
  Link: {
    cursor: 'pointer'
  }
};
